<template>
  <!-- <span class="bg"></span> -->
  <v-app style=" background: #EFEFEF; background: -webkit-linear-gradient(to bottom,  #EFEFEF, #D7D7D7, #AAA); background: linear-gradient(to bottom, #EFEFEF, #D7D7D7, #AAA); ">
    <v-app-bar app color="#FFF" light>
      <v-avatar :tile="true" width="300">
      <v-img
          alt="MLE Logo"
          class="shrink mr-2"
          contain
          :src="images.sample"
          transition="scale-transition"
        />
    </v-avatar>
      <div class="d-flex align-center">
      </div>
      <v-spacer></v-spacer>
      <v-icon class="mx-1">mdi-book-open-page-variant</v-icon>
      <v-app-bar-title class="text-truncate">
        <b>Register for ML Competences, ML Hard- & Software Ressources</b>
      </v-app-bar-title>
      <v-spacer></v-spacer>

      <v-btn href="http://www.mle.hamburg/" target="_blank" text>
        <span class="mr-2" dark>MLE Home</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </v-app-bar>
    <v-main>
      <v-container fluid>
          <v-layout row wrap class="ma-10">
            <v-flex v-if="!backendconnection">
                <apiComponent />
              </v-flex>
              <v-flex v-if="backendconnection">
                <mainComponent />
              </v-flex>
          </v-layout>
        </v-container>
    </v-main>
    <v-footer padless>
    <v-col cols="1">
    </v-col>
    <v-col
      class="text-center"
      cols="10"
    >
      {{ new Date().getFullYear() }} — Created & maintained by <strong><a href="https://www.mle.hamburg/authors/jahn/" target="_blank">Niklas Jahn</a></strong>
    </v-col>
    <v-col cols="1">
      <v-btn
      color="blue-grey"
      class="ma-2 white--text"
      href="mailto:niklas.jahn@tuhh.de?subject=MLE%20Register%20Bug%20Report"
      text
    >
      Report a Bug
      <v-icon
        right
        dark
      >
        mdi-bug
      </v-icon>
    </v-btn>
    </v-col>
  </v-footer>
  </v-app>
</template>

<!--
<v-parallax src="https://www.speexx.com/wp-content/uploads/artificial-intelligence-blur-close-up-546819-1.jpg"> </v-parallax>
-->

<script>
import mainComponent from './components/mainComponent'
import apiComponent from './components/backendConnectionComponent'
import APIService from '@/services/APIService'

export default {
  name: 'App',

  components: {
    mainComponent,
    apiComponent
  },

  data: () => ({
    images: {
      sample: require('./assets/mlelogo.svg')
    },
    backendconnection: false
  }),
  methods: {
    async getLiveness () {
      const response = await APIService.livenessProbe()
      console.log(response.status)
      this.backendconnection = response.status === 200
    }
  },
  mounted () {
    this.getLiveness()
  }
}
</script>

<style>
.parallax {
  min-height: 100vh;
  align-items: top;
}
</style>



// WEBPACK FOOTER //
// src/App.vue